"use strict";


/*export*/  class SettingsInjections  {

  static getUsedCircuit()  {
    return utils_api.frozenMerge( SettingsInjections._circuit );
  }


  static getUsedCircuitName()  {
    return SettingsInjections._circuitName;
  }


  static getUsedLocale()  {
    //  HINT: its defaulting, not merging!
    return utils_api.frozenMerge( SettingsInjections._Locale ||
                                  {  name : "english",  code : "en_US",  icon : "en",  enabled : true  });
  }

  static getUsedCurrency() {
    return utils_api.frozenMerge({
      "wallet": SettingsInjections._Currency || "usd",
      "market": "gjn"
    });
  }


  static getCredentials()  {
    return utils_api.frozenMerge(
      { token : '', userId : 0, nick : '' },
      SettingsInjections._creds
    );
  }

  static setCredentials( creds )  {
    SettingsInjections._creds = Object.assign( {}, creds );
  }

  static getVersion()  {
    return "@@BUILDSTAMPMARK@@";
  }
};


